import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=46cb931a&scoped=true"
import script from "./addUser.vue?vue&type=script&lang=js"
export * from "./addUser.vue?vue&type=script&lang=js"
import style0 from "./addUser.vue?vue&type=style&index=0&id=46cb931a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb931a",
  null
  
)

export default component.exports